var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-header-index-wide"},[_c('s-breadcrumb')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }